/**
 * @param {{metatag_description:any,metatag_image:any}} data
 */
import React, { useEffect, useState } from "react";
import PageMeta from "../../components/PageMeta";
import ComponentComposer from "../../components/ComponentComposer";
import { fetchBonusPuzzle } from "../../api/cms";
import { useParams } from "react-router-dom";
import { BonusPuzzlePageType } from "../../types";
import AnalyticsPageLoad from "../../components/AnalyticsPageLoad/AnalyticsPageLoad";

const BonusPuzzlePage: React.FC<BonusPuzzlePageType> = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [pageTitle, setPageTitle] = useState<string>("Bonus Puzzle");
  const [sitePageTitle, setPageTitle_] =useState("Bonus Puzzle");
  const [basicMetaTags, setBasicMetaTags] = useState<any>({});
  const [ogMetaTags, setOgMetaTags] = useState<any>({});
  const [twitterMetaTags, setTwitterMetaTags] = useState<any>({});

  const { id } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchBonusPuzzle(id !== undefined ? id : 0);

      if (!data || !data.components || data.error === true) {
        return;
      }
      setIsLoaded(true);
      setData(data.components);
      setPageTitle(data.page.title || "Bonus Puzzle");

      if (data.page.page_title && data.page.page_title !== "" && data.page.page_title !== undefined) {
        setPageTitle_(data.page.page_title);
      }

      if (data.page.basic_meta_tags && data.page.basic_meta_tags !== "" && data.page.basic_meta_tags !== undefined) {
        setBasicMetaTags(data.page.basic_meta_tags);
      }
      
      if (data.page.og_meta_tags && data.page.og_meta_tags !== "" && data.page.og_meta_tags !== undefined) {
        setOgMetaTags(data.page.og_meta_tags);
      }

      if (data.page.twitter_meta_tags && data.page.twitter_meta_tags !== "" && data.page.twitter_meta_tags !== undefined) {
        setTwitterMetaTags(data.page.twitter_meta_tags);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bonus-puzzle-page wof-react-component remove-bg">
      {isLoaded && <AnalyticsPageLoad contentTitle={pageTitle} />}
      <PageMeta
      sitePageTitle={sitePageTitle}
      ogMetaTags={ogMetaTags}
      basicMetaTags={basicMetaTags}
      twitterMetaTags={twitterMetaTags}
      />
      {data && data.map((d, i) => <ComponentComposer key={i} {...d} />)}
    </div>
  );
};

export default BonusPuzzlePage;
